var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { openMenu, closeMenu } from "../actions/contextMenuActions";

export class ContextMenu extends Component {
  render() {
    const children = React.Children.map(this.props.children, (child) => child) || [];
    let SubMenu = children.filter((child) => {
      const forceShow = this.props.overrideShow && this.props.show;
      const matchesType = child.type.name === this.props.type;
      const matchesWrap =
      child.type.WrappedComponent && child.type.WrappedComponent.name === this.props.type;
      return forceShow || matchesType || matchesWrap;
    });

    const position = `ContextMenu-${this.props.align || 'bottom'}`;

    SubMenu = React.Children.map(SubMenu, (child) => /*#__PURE__*/
    React.cloneElement(child, { active: this.props.open }));


    return /*#__PURE__*/(
      _jsx("div", {
        className: `ContextMenu ${position}`,
        onMouseEnter: this.props.openMenu,
        onMouseLeave: this.props.closeMenu,
        onClick: this.props.closeMenu }, void 0,

      SubMenu));


  }
}















const mapStateToProps = (state) => state.contextMenu.toJS();

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ openMenu, closeMenu }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ContextMenu);